<br *ngIf="!!node && !!node.icon">
<label class="material-checkbox" [ngClass]="{'dark-check': useDarkCheck(node)}">
  <input
    [checked]="node.checked"
    (click)="emitChange()"
    type="checkbox">
  <span class="sp">
    <span class="checkbox-bg" [style.background-color]="node.filter.color || ''"></span>
    <img *ngIf="!!node.icon" [src]="node.icon" [alt]="node.filter.name">
    <i *ngIf="!node.icon">{{node.filter.name}}</i>
  </span>
</label>
<br *ngIf="!!node && !!node.icon">
